module.exports = __webpack_public_path__ + "img/40.6b03ae75.png";